"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AssetMarker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _map = require("@nicbase/map");

var _mapping = require("@nicbase/mapping");

var _nicbaseTooltipData = _interopRequireDefault(require("nicbase-tooltip-data"));

var _tooltip = _interopRequireDefault(require("./tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AssetMarker = function AssetMarker(_ref) {
  var properties = _ref.properties,
      lat = _ref.lat,
      lng = _ref.lng;
  var id = properties.id,
      _properties$common = properties.common,
      common = _properties$common === void 0 ? {} : _properties$common,
      type = properties.type,
      name = properties.name,
      _properties$position = properties.position,
      position = _properties$position === void 0 ? {} : _properties$position,
      _properties$reefer = properties.reefer,
      reefer = _properties$reefer === void 0 ? {} : _properties$reefer;
  var _common$status = common.status,
      status = _common$status === void 0 ? [] : _common$status,
      date = common.date,
      mileage = common.mileage,
      speed = common.speed;
  var address = position.properties.address;
  var _reefer$temperatures = reefer.temperatures,
      temperatures = _reefer$temperatures === void 0 ? {} : _reefer$temperatures,
      _reefer$setpoints = reefer.setpoints,
      setpoints = _reefer$setpoints === void 0 ? {} : _reefer$setpoints,
      _reefer$returnAir = reefer.returnAir,
      returnAir = _reefer$returnAir === void 0 ? {} : _reefer$returnAir,
      _reefer$supplyAir = reefer.supplyAir,
      supplyAir = _reefer$supplyAir === void 0 ? {} : _reefer$supplyAir;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTooltip = _useState2[0],
      setShowTooltip = _useState2[1];

  var tooltipRef = (0, _react.useRef)();
  var left = 0;
  var top = 0;

  if (tooltipRef.current) {
    var _tooltipRef$current$g = tooltipRef.current.getBoundingClientRect(),
        width = _tooltipRef$current$g.width;

    var _tooltipRef$current$g2 = tooltipRef.current.getBoundingClientRect();

    left = _tooltipRef$current$g2.left;
    top = _tooltipRef$current$g2.top;
    left += width / 2;
    top -= 4; // for tooltip caret
  }

  var moveState = status.some(function (state) {
    return state.type === 'DRIVING';
  }) ? 'DRIVING' : 'STANDING';
  var isEmpty = !status.some(function (state) {
    return state.type === 'LOADED';
  });
  var oldStatusStructur = status.map(function (state) {
    return state.type;
  });
  var newTooltipData = (0, _react.useMemo)(function () {
    return {
      id: id,
      name: name,
      type: type,
      date: date,
      mileage: mileage,
      temperatures: temperatures,
      speed: speed,
      setpoint1: setpoints[1],
      reeferReturn1: returnAir[1],
      supplyAir1: supplyAir[1],
      status: oldStatusStructur,
      position: address
    };
  }, [address, date, id, mileage, name, oldStatusStructur, returnAir, setpoints, speed, supplyAir, temperatures, type]);
  var AssetIcon = (0, _mapping.assetToIcon)(type, moveState);
  return /*#__PURE__*/_react["default"].createElement(_map.Marker, {
    lat: lat,
    lng: lng
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "button",
    className: "bg-white p-1 rounded flex items-center text-sm outline-none shadow hover:shadow-md focus:ring",
    ref: tooltipRef,
    tabIndex: 0,
    "aria-label": name,
    onMouseEnter: function onMouseEnter() {
      setShowTooltip(true);
    },
    onFocus: function onFocus() {
      setShowTooltip(true);
    },
    onMouseLeave: function onMouseLeave() {
      setShowTooltip(false);
    },
    onBlur: function onBlur() {
      setShowTooltip(false);
    }
  }, AssetIcon && /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-5 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement(AssetIcon, {
    className: "h-5 w-10",
    movementType: moveState,
    isEmpty: isEmpty
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-1 whitespace-nowrap text-primary font-bold"
  }, name)), showTooltip ? /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    top: top,
    left: left
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTooltipData["default"], {
    nicData: [newTooltipData]
  })) : null));
};

exports.AssetMarker = AssetMarker;
AssetMarker.propTypes = {
  properties: _propTypes["default"].shape({
    id: _propTypes["default"].number,
    common: _propTypes["default"].shape({
      date: _propTypes["default"].string,
      mileage: _propTypes["default"].string,
      speed: _propTypes["default"].string,
      status: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        type: _propTypes["default"].string
      }))
    }),
    position: _propTypes["default"].shape({
      properties: _propTypes["default"].shape({
        address: _propTypes["default"].shape({})
      })
    }),
    reefer: _propTypes["default"].shape({
      temperatures: _propTypes["default"].shape({}),
      setpoints: _propTypes["default"].shape({}),
      returnAir: _propTypes["default"].shape({}),
      supplyAir: _propTypes["default"].shape({})
    }),
    type: _propTypes["default"].number,
    name: _propTypes["default"].string
  }).isRequired,
  lat: _propTypes["default"].number.isRequired,
  lng: _propTypes["default"].number.isRequired
};
var _default = AssetMarker;
exports["default"] = _default;